export default __webpack_public_path__ + "static/media/check-white.76c7eb9d.svg";